module.exports = __webpack_public_path__ + "career-icon-hours.1QYG_LN7.svg";